import { computed, Signal } from '@angular/core';

import { SiteId } from 'app/site-detail/models/Site';

import { useVideoCallButtonState, VideoCallButtonOwner } from './use-video-call-button-state';
import { useVideoCallWorkflow, UseVideoCallOptions } from './use-video-call-workflow';

/** `owner` is the installation's client: inviting needs one, joining a call the client already joined does not. */
export function useVideoCall(
    siteId: Signal<SiteId | undefined>,
    owner: Signal<VideoCallButtonOwner>,
    options: UseVideoCallOptions,
) {
    const buttonState = useVideoCallButtonState(siteId, owner);
    const workflow = useVideoCallWorkflow(siteId, buttonState.vm, options);
    const joinable = computed(
        () => buttonState.action() === 'JOIN_VIDEO_CALL' || buttonState.action() === 'STOP_AND_JOIN_VIDEO_CALL',
    );
    const disabled = computed(
        () => workflow.loading() || buttonState.unavailable() || (!buttonState.visible() && !joinable()),
    );

    return {
        button: {
            action: buttonState.action,
            label: buttonState.label,
            visible: buttonState.visible,
            disabled,
            loading: workflow.loading,
            joinable,
            handleAction: workflow.handleAction,
        },
        confirmation: {
            open: workflow.invitationConfirmationOpen,
            close: workflow.closeInvitationConfirmation,
            confirm: workflow.confirmInvitation,
        },
        error: workflow.error,
    };
}
